<template>
  <div class="search-box">
    <div class="search-tip">
      <p>{{ $t("comprehensiveInquiry") }}</p>
    </div>
    <div class="form-box">
      <el-form label-width="170px" :model="searchForm" label-suffix=":">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('catgoriesList')">
              <el-select
                size="small"
                clearable
                v-model="searchForm.cl_Na"
                :placeholder="$t('selectPlaceholder')"
                class="select-block"
              >
                <el-option
                  v-for="item in treeData"
                  :key="item.cl_Na"
                  :label="item[$hs('cl_Na', 'cl_Ne_Na', 'threeLanguage')]"
                  :value="item.cl_Nu"
                  >{{
                    language == "ru" ? item["threeLanguage"] : language == "zh" ? item["cl_Na"] : item["cl_Ne_Na"]
                  }}</el-option
                >
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('productName')">
              <el-input size="small" v-model="searchForm.pr_Na" :placeholder="$t('productNameplace')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('cartonSize')">
              <el-col :span="6">
                <el-input
                  size="small"
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  v-model="searchForm.ou_Le"
                  :placeholder="$t('L')"
                ></el-input>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="6">
                <el-input
                  size="small"
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  v-model="searchForm.ou_Wi"
                  :placeholder="$t('W')"
                ></el-input>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="6">
                <el-input
                  size="small"
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  v-model="searchForm.ou_Hi"
                  :placeholder="$t('H')"
                ></el-input>
              </el-col>
              <el-col class="tip" :span="2">CM</el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('packing')">
              <el-select
                size="small"
                clearable
                v-model="searchForm.pa_Nu"
                :placeholder="$t('packingplacehover')"
                class="select-block"
              >
                <el-option
                  v-for="item in packList"
                  :key="item.pa_Nu"
                  :label="item[$hs('ch_Pa', 'en_Pa', 'threeLanguage')]"
                  :value="item.pa_Nu"
                  >{{
                    language == "ru" ? item["threeLanguage"] : language == "zh" ? item["ch_Pa"] : item["en_Pa"]
                  }}</el-option
                >
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('packingCapacity')">
              <el-col :span="11">
                <el-input
                  size="small"
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  v-model="searchForm.ou_Lo"
                  :placeholder="$t('packingCapacity')"
                ></el-input>
              </el-col>
              <el-col class="line" style="text-align: center" :span="2">-</el-col>
              <el-col :span="11">
                <el-input
                  size="small"
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  v-model="searchForm.ou_Lo2"
                  :placeholder="$t('packingCapacity')"
                ></el-input>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('Entrytime')">
              <el-col :span="11">
                <el-date-picker
                  type="date"
                  value-format="yyyy-MM-dd"
                  v-model="searchForm.date1"
                  style="width: 100%"
                  :placeholder="$t('Entrytimeplace')"
                ></el-date-picker>
              </el-col>
              <el-col class="line" style="text-align: center" :span="2">-</el-col>
              <el-col :span="11">
                <el-date-picker
                  type="date"
                  value-format="yyyy-MM-dd"
                  v-model="searchForm.date2"
                  style="width: 100%"
                  :placeholder="$t('Entrytimeplace')"
                ></el-date-picker>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('coNuNum')">
              <el-input
                type="textarea"
                :rows="4"
                :placeholder="$t('coNuNumPlaceholder')"
                v-model="searchForm.co_Nu"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('PriceRange')" v-if=" userInfo.id">
              <el-col :span="11">
                <el-input
                  size="small"
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  v-model="searchForm.price1"
                  :placeholder="$t('PriceRange3')"
                ></el-input>
              </el-col>
              <el-col class="line" style="text-align: center" :span="2">-</el-col>
              <el-col :span="11">
                <el-input
                  size="small"
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  v-model="searchForm.price2"
                  :placeholder="$t('PriceRange2')"
                ></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="筛选">
              <el-radio-group v-model="productType" @change="productTypeChange">
                <el-radio :label="0">{{ $t("Screening1") }}</el-radio>
                <el-radio :label="1">{{ $t("Screening2") }}</el-radio>
                <el-radio :label="2">{{ $t("Screening3") }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div class="actionList">
              <el-button size="small" type="info" plain @click="reset" class="reset">{{ $t("reset") }}</el-button>
              <el-button size="small" type="primary" @click="search" class="subtm">
                {{ $t("search") }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { mapState,mapGetters } from "vuex";

import { getPackList, getClassList } from "@/api/product";
export default {
  data() {
    return {
      isOpen: true,
      packList: [],
      treeData: [],
      productType: 0,
      searchForm: {
        pr_Na: "",
        fa_No: "",
        pa_Nu: "",
        pr_Hi: "",
        pr_Le: "",
        pr_Wi: "",
        ou_Hi: "",
        ou_Le: "",
        ou_Wi: "",
        in_Le: "",
        in_Wi: "",
        in_Hi: "",
        ou_Lo: "",
        ou_Lo2: "",
        cl_Na: "",
        co_Nu: "",
        date1: null,
        date2: null,
        price2: "",
        price1: "",
      },
    };
  },
  computed: {
    ...mapState("operate", ["language"]),
    ...mapGetters("user", {
      userInfo: "get_userInfo",
    }),
  },
  created() {
    this.packMethodList();
    this.pagegetClassList();
  },
  methods: {
    productTypeChange() {
      this.$emit("productTypeChange");
    },
    pagegetClassList() {
      getClassList().then((res) => {
        if (res.success) {
          this.treeData = res.data;
        }
      });
    },
    packMethodList() {
      getPackList().then((res) => {
        if (res.success) {
          this.packList = res.data;
        }
      });
    },
    // 搜索
    search() {
      let keys = ["cl_Na", "pa_Nu", "pr_Na"];
      const conditionals = [];
      console.log(Object.keys(this.searchForm));
      Object.keys(this.searchForm).forEach((item) => {
        console.log(keys.includes(item) && this.searchForm[item]);
        if (keys.includes(item) && this.searchForm[item]) {
          conditionals.push({
            conditionalType: 1, // 1为模糊搜索
            fieldName: item,
            key: 0,
            fieldValue: this.searchForm[item],
          });
        }
        if ((item == "ou_Le" || item == "ou_Wi" || item == "ou_Hi") && this.searchForm[item]) {
          conditionals.push({
            conditionalType: 0, // 1为模糊搜索
            fieldName: item,
            key: 0,
            fieldValue: this.searchForm[item],
          });
        }
        if (item == "co_Nu" && this.searchForm[item]) {
          conditionals.push({
            conditionalType: 6,
            fieldValue: this.searchForm[item].replaceAll("\n", ","),
            key: 0,
            fieldName: "co_Nu",
          });
        }
        if (item == "date1" && this.searchForm[item]) {
          conditionals.push({
            conditionalType: 3,
            fieldName: "createdTime",
            fieldValue: this.searchForm[item] + " 00:00:00",
            key: 0,
          });
        }
        if (item == "date2" && this.searchForm[item]) {
          conditionals.push({
            conditionalType: 5,
            fieldName: "createdTime",
            fieldValue: this.searchForm[item] + " 23:59:59",
            key: 0,
          });
        }
        if (item == "ou_Lo" && this.searchForm[item]) {
          conditionals.push({
            conditionalType: 3,
            fieldName: "ou_Lo",
            fieldValue: this.searchForm[item] + " 00:00:00",
            key: 0,
          });
        }
        if (item == "ou_Lo2" && this.searchForm[item]) {
          conditionals.push({
            conditionalType: 5,
            fieldName: "ou_Lo",
            fieldValue: this.searchForm[item] + " 23:59:59",
            key: 0,
          });
        }
        if (item == "price1" && this.searchForm[item]) {
          conditionals.push({
            conditionalType: 3,
            fieldName: "price",
            fieldValue: this.searchForm[item],
            key: 0,
          });
        }
        if (item == "price2" && this.searchForm[item]) {
          conditionals.push({
            conditionalType: 5,
            fieldName: "price",
            fieldValue: this.searchForm[item],
            key: 0,
          });
        }
      });
      console.log(conditionals);
      this.$emit("search", conditionals);
      this.reset();
    },
    // 重置表单
    reset() {
      this.searchForm = {
        pr_Na: "",
        fa_No: "",
        pa_Nu: "",
        pr_Hi: "",
        pr_Le: "",
        pr_Wi: "",
        ou_Hi: "",
        ou_Le: "",
        ou_Wi: "",
        in_Le: "",
        in_Wi: "",
        in_Hi: "",
        ou_Lo: "",
        ou_Lo2: "",
        cl_Na: "",
        co_Nu: "",
        date1: null,
        date2: null,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.search-box {
  color: #333;
  font-size: 14px;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;

  & .search-tip {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  & .form-box {
    padding-top: 20px;

    & .select-block {
      width: 100%;
    }

    & .btn-search {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      & .el-button {
        font-size: 14px;
      }
    }

    & .line {
      text-align: center;
    }

    & .tip {
      text-align: center;
      font-size: 12px;
    }

    .actionList {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .reset {
        width: 100px;
        height: 40px;
        background: #ff0000;
        border: 1px solid#ff0000;
        border-radius: 4px;
        font-size: 14px;
        color: white;
      }
      .subtm {
        width: 100px;
        height: 40px;
        background: #d871b8;
        border: 1px solid#d871b8;
        border-radius: 4px;
        font-size: 14px;
        color: white;
      }
    }
  }
}
::v-deep .el-input__inner {
  height: 38px !important;
}

::v-deep .actionList button {
  margin-right: 0px !important;
}
</style>
